import { Injectable } from '@angular/core';
import { ITimeZoneService } from './itime-zone.service';
import { TimeZone } from './time-zone.model';
import { ApiService, ApiCacheOptions } from '../../../shared/index';

@Injectable({ providedIn: 'root' })
export class TimeZoneService implements ITimeZoneService {
  public _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public getTimeZones(): Promise<Array<TimeZone>> {
    return this._apiService.get('Config/TimeZones', this._cacheOptions).then((data: Array<TimeZone>) => {
      return Promise.resolve(data);
    });
  }

  public getDefaultTimeZone = (): Promise<TimeZone> => {
    return this._apiService.get('Config/DefaultTimeZone', this._cacheOptions).then((data: TimeZone) => {
      return Promise.resolve(data);
    });
  }

  public getTimeZone(tzId: number): Promise<TimeZone> {
    return this._apiService.get(`Config/TimeZones/${tzId}`, this._cacheOptions);
  }
}
